import type { FC } from 'react';
import React from 'react';
import { Icon } from '@/components';
import { MapSwitch } from './MapSwitch';
import { type CustomIconName } from '@/components/Icon/Icon';
import classes from './MapLayerGroupControl.module.css';

interface Props {
  title: string;
  icon?: CustomIconName;
  description?: string;
  isGroupVisible: boolean;
  onVisibilityChange: (checked: boolean) => void;
  children?: React.ReactNode;
  'data-testid'?: string;
}

export const MapLayerGroupControl: FC<Props> = (props) => {
  return (
    <div className={classes.wrapper} data-testid={props['data-testid']}>
      <div>
        <div className={classes.groupTitle}>
          <span>
            {props.icon && <Icon name={props.icon} size={18} />} {props.title}
          </span>
          <MapSwitch
            onChange={props.onVisibilityChange}
            isChecked={props.isGroupVisible}
            testId={
              props['data-testid']
                ? `${props['data-testid']}-switch`
                : undefined
            }
          />
        </div>
        {props.description && (
          <div className={classes.groupDescription}>{props.description}</div>
        )}
      </div>
      {props.isGroupVisible && props.children && (
        <div className={classes.optionsWrapper}>{props.children}</div>
      )}
    </div>
  );
};
